import _defineProperty from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createSuper";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @packageDocumentation
 * @module Voice
 */


import { EventEmitter } from 'events';
import Device from './device';
import { InvalidArgumentError, NotSupportedError } from './errors';
import Log from './log';
import OutputDeviceCollection from './outputdevicecollection';
import MediaDeviceInfoShim from './shims/mediadeviceinfo';
import { average, difference } from './util';
/**
 * Aliases for audio kinds, used for labelling.
 * @private
 */

var kindAliases = {
  audioinput: 'Audio Input',
  audiooutput: 'Audio Output'
};
/**
 * Provides input and output audio-based functionality in one convenient class.
 * @publicapi
 */

var AudioHelper = /*#__PURE__*/function (_EventEmitter) {
  _inherits(AudioHelper, _EventEmitter);

  var _super = _createSuper(AudioHelper);

  /**
   * @constructor
   * @private
   * @param onActiveOutputsChanged - A callback to be called when the user changes the active output devices.
   * @param onActiveInputChanged - A callback to be called when the user changes the active input device.
   * @param [options]
   */
  function AudioHelper(onActiveOutputsChanged, onActiveInputChanged, options) {
    var _this$_enabledSounds;

    var _this;

    _classCallCheck(this, AudioHelper);

    _this = _super.call(this);
    /**
     * A Map of all audio input devices currently available to the browser by their device ID.
     */

    _this.availableInputDevices = new Map();
    /**
     * A Map of all audio output devices currently available to the browser by their device ID.
     */

    _this.availableOutputDevices = new Map();
    /**
     * The currently set audio constraints set by setAudioConstraints().
     */

    _this._audioConstraints = null;
    /**
     * The audio stream of the default device.
     * This is populated when _openDefaultDeviceWithConstraints is called,
     * See _selectedInputDeviceStream for differences.
     * TODO: Combine these two workflows (3.x?)
     */

    _this._defaultInputDeviceStream = null;
    /**
     * Whether each sound is enabled.
     */

    _this._enabledSounds = (_this$_enabledSounds = {}, _defineProperty(_this$_enabledSounds, Device.SoundName.Disconnect, true), _defineProperty(_this$_enabledSounds, Device.SoundName.Incoming, true), _defineProperty(_this$_enabledSounds, Device.SoundName.Outgoing, true), _this$_enabledSounds);
    /**
     * The current input device.
     */

    _this._inputDevice = null;
    /**
     * The internal promise created when calling setInputDevice
     */

    _this._inputDevicePromise = null;
    /**
     * Whether the {@link AudioHelper} is currently polling the input stream's volume.
     */

    _this._isPollingInputVolume = false;
    /**
     * An instance of Logger to use.
     */

    _this._log = new Log('AudioHelper');
    /**
     * Internal reference to the processed stream
     */

    _this._processedStream = null;
    /**
     * The selected input stream coming from the microphone device.
     * This is populated when the setInputDevice is called, meaning,
     * the end user manually selected it, which is different than
     * the defaultInputDeviceStream.
     * TODO: Combine these two workflows (3.x?)
     */

    _this._selectedInputDeviceStream = null;
    /**
     * A record of unknown devices (Devices without labels)
     */

    _this._unknownDeviceIndexes = {
      audioinput: {},
      audiooutput: {}
    };
    /**
     * Update the available input and output devices
     * @private
     */

    _this._updateAvailableDevices = function () {
      if (!_this._mediaDevices || !_this._enumerateDevices) {
        return Promise.reject('Enumeration not supported');
      }

      return _this._enumerateDevices().then(function (devices) {
        _this._updateDevices(devices.filter(function (d) {
          return d.kind === 'audiooutput';
        }), _this.availableOutputDevices, _this._removeLostOutput);

        _this._updateDevices(devices.filter(function (d) {
          return d.kind === 'audioinput';
        }), _this.availableInputDevices, _this._removeLostInput);

        var defaultDevice = _this.availableOutputDevices.get('default') || Array.from(_this.availableOutputDevices.values())[0];
        [_this.speakerDevices, _this.ringtoneDevices].forEach(function (outputDevices) {
          if (!outputDevices.get().size && _this.availableOutputDevices.size && _this.isOutputSelectionSupported) {
            outputDevices.set(defaultDevice.deviceId).catch(function (reason) {
              _this._log.warn("Unable to set audio output devices. ".concat(reason));
            });
          }
        });
      });
    };
    /**
     * Remove an input device from inputs
     * @param lostDevice
     * @returns Whether the device was active
     */


    _this._removeLostInput = function (lostDevice) {
      if (!_this.inputDevice || _this.inputDevice.deviceId !== lostDevice.deviceId) {
        return false;
      }

      _this._destroyProcessedStream();

      _this._replaceStream(null);

      _this._inputDevice = null;

      _this._maybeStopPollingVolume();

      var defaultDevice = _this.availableInputDevices.get('default') || Array.from(_this.availableInputDevices.values())[0];

      if (defaultDevice) {
        _this.setInputDevice(defaultDevice.deviceId);
      }

      return true;
    };
    /**
     * Remove an input device from outputs
     * @param lostDevice
     * @returns Whether the device was active
     */


    _this._removeLostOutput = function (lostDevice) {
      var wasSpeakerLost = _this.speakerDevices.delete(lostDevice);

      var wasRingtoneLost = _this.ringtoneDevices.delete(lostDevice);

      return wasSpeakerLost || wasRingtoneLost;
    };

    options = Object.assign({
      AudioContext: typeof AudioContext !== 'undefined' && AudioContext,
      setSinkId: typeof HTMLAudioElement !== 'undefined' && HTMLAudioElement.prototype.setSinkId
    }, options);

    _this._beforeSetInputDevice = options.beforeSetInputDevice || function () {
      return Promise.resolve();
    };

    _this._updateUserOptions(options);

    _this._audioProcessorEventObserver = options.audioProcessorEventObserver;
    _this._mediaDevices = options.mediaDevices || navigator.mediaDevices;
    _this._onActiveInputChanged = onActiveInputChanged;
    _this._enumerateDevices = typeof options.enumerateDevices === 'function' ? options.enumerateDevices : _this._mediaDevices && _this._mediaDevices.enumerateDevices.bind(_this._mediaDevices);
    var isAudioContextSupported = !!(options.AudioContext || options.audioContext);
    var isEnumerationSupported = !!_this._enumerateDevices;

    if (options.enabledSounds) {
      _this._enabledSounds = options.enabledSounds;
    }

    var isSetSinkSupported = typeof options.setSinkId === 'function';
    _this.isOutputSelectionSupported = isEnumerationSupported && isSetSinkSupported;
    _this.isVolumeSupported = isAudioContextSupported;

    if (_this.isVolumeSupported) {
      _this._audioContext = options.audioContext || options.AudioContext && new options.AudioContext();

      if (_this._audioContext) {
        _this._inputVolumeAnalyser = _this._audioContext.createAnalyser();
        _this._inputVolumeAnalyser.fftSize = 32;
        _this._inputVolumeAnalyser.smoothingTimeConstant = 0.3;
      }
    }

    _this.ringtoneDevices = new OutputDeviceCollection('ringtone', _this.availableOutputDevices, onActiveOutputsChanged, _this.isOutputSelectionSupported);
    _this.speakerDevices = new OutputDeviceCollection('speaker', _this.availableOutputDevices, onActiveOutputsChanged, _this.isOutputSelectionSupported);

    _this.addListener('newListener', function (eventName) {
      if (eventName === 'inputVolume') {
        _this._maybeStartPollingVolume();
      }
    });

    _this.addListener('removeListener', function (eventName) {
      if (eventName === 'inputVolume') {
        _this._maybeStopPollingVolume();
      }
    });

    _this.once('newListener', function () {
      // NOTE (rrowland): Ideally we would only check isEnumerationSupported here, but
      //   in at least one browser version (Tested in FF48) enumerateDevices actually
      //   returns bad data for the listed devices. Instead, we check for
      //   isOutputSelectionSupported to avoid these quirks that may negatively affect customers.
      if (!_this.isOutputSelectionSupported) {
        _this._log.warn('Warning: This browser does not support audio output selection.');
      }

      if (!_this.isVolumeSupported) {
        _this._log.warn("Warning: This browser does not support Twilio's volume indicator feature.");
      }
    });

    if (isEnumerationSupported) {
      _this._initializeEnumeration();
    } // NOTE (kchoy): Currently microphone permissions are not supported in firefox, and Safari V15 and older.
    // https://github.com/mozilla/standards-positions/issues/19#issuecomment-370158947
    // https://caniuse.com/permissions-api


    if (navigator && navigator.permissions && typeof navigator.permissions.query === 'function') {
      navigator.permissions.query({
        name: 'microphone'
      }).then(function (microphonePermissionStatus) {
        if (microphonePermissionStatus.state !== 'granted') {
          var handleStateChange = function handleStateChange() {
            _this._updateAvailableDevices();

            _this._stopMicrophonePermissionListener();
          };

          microphonePermissionStatus.addEventListener('change', handleStateChange);
          _this._microphonePermissionStatus = microphonePermissionStatus;
          _this._onMicrophonePermissionStatusChanged = handleStateChange;
        }
      }).catch(function (reason) {
        return _this._log.warn("Warning: unable to listen for microphone permission changes. ".concat(reason));
      });
    } else {
      _this._log.warn('Warning: current browser does not support permissions API.');
    }

    return _this;
  }
  /**
   * The currently set audio constraints set by setAudioConstraints(). Starts as null.
   */


  _createClass(AudioHelper, [{
    key: "audioConstraints",
    get: function get() {
      return this._audioConstraints;
    }
    /**
     * The active input device. Having no inputDevice specified by `setInputDevice()`
     * will disable input selection related functionality.
     */

  }, {
    key: "inputDevice",
    get: function get() {
      return this._inputDevice;
    }
    /**
     * The current input stream coming from the microphone device or
     * the processed audio stream if there is an {@link AudioProcessor}.
     */

  }, {
    key: "inputStream",
    get: function get() {
      return this._processedStream || this._selectedInputDeviceStream;
    }
    /**
     * The processed stream if an {@link AudioProcessor} was previously added.
     */

  }, {
    key: "processedStream",
    get: function get() {
      return this._processedStream;
    }
    /**
     * Destroy this AudioHelper instance
     * @private
     */

  }, {
    key: "_destroy",
    value: function _destroy() {
      this._stopDefaultInputDeviceStream();

      this._stopSelectedInputDeviceStream();

      this._destroyProcessedStream();

      this._maybeStopPollingVolume();

      this.removeAllListeners();

      this._stopMicrophonePermissionListener();

      this._unbind();
    }
    /**
     * Promise to wait for the input device, if setInputDevice is called outside of the SDK
     * @private
     */

  }, {
    key: "_getInputDevicePromise",
    value: function _getInputDevicePromise() {
      return this._inputDevicePromise;
    }
    /**
     * Start polling volume if it's supported and there's an input stream to poll.
     * @private
     */

  }, {
    key: "_maybeStartPollingVolume",
    value: function _maybeStartPollingVolume() {
      var _this2 = this;

      if (!this.isVolumeSupported || !this.inputStream) {
        return;
      }

      this._updateVolumeSource();

      if (this._isPollingInputVolume || !this._inputVolumeAnalyser) {
        return;
      }

      var bufferLength = this._inputVolumeAnalyser.frequencyBinCount;
      var buffer = new Uint8Array(bufferLength);
      this._isPollingInputVolume = true;

      var emitVolume = function emitVolume() {
        if (!_this2._isPollingInputVolume) {
          return;
        }

        if (_this2._inputVolumeAnalyser) {
          _this2._inputVolumeAnalyser.getByteFrequencyData(buffer);

          var inputVolume = average(buffer);

          _this2.emit('inputVolume', inputVolume / 255);
        }

        requestAnimationFrame(emitVolume);
      };

      requestAnimationFrame(emitVolume);
    }
    /**
     * Stop polling volume if it's currently polling and there are no listeners.
     * @private
     */

  }, {
    key: "_maybeStopPollingVolume",
    value: function _maybeStopPollingVolume() {
      if (!this.isVolumeSupported) {
        return;
      }

      if (!this._isPollingInputVolume || this.inputStream && this.listenerCount('inputVolume')) {
        return;
      }

      if (this._inputVolumeSource) {
        this._inputVolumeSource.disconnect();

        delete this._inputVolumeSource;
      }

      this._isPollingInputVolume = false;
    }
    /**
     * Call getUserMedia with specified constraints
     * @private
     */

  }, {
    key: "_openDefaultDeviceWithConstraints",
    value: function _openDefaultDeviceWithConstraints(constraints) {
      var _this3 = this;

      this._log.info('Opening default device with constraints', constraints);

      return this._getUserMedia(constraints).then(function (stream) {
        _this3._log.info('Opened default device. Updating available devices.'); // Ensures deviceId's and labels are populated after the gUM call
        // by calling enumerateDevices


        _this3._updateAvailableDevices().catch(function (error) {
          // Ignore error, we don't want to break the call flow
          _this3._log.warn('Unable to updateAvailableDevices after gUM call', error);
        });

        _this3._defaultInputDeviceStream = stream;
        return _this3._maybeCreateProcessedStream(stream);
      });
    }
    /**
     * Stop the default audio stream
     * @private
     */

  }, {
    key: "_stopDefaultInputDeviceStream",
    value: function _stopDefaultInputDeviceStream() {
      if (this._defaultInputDeviceStream) {
        this._log.info('stopping default device stream');

        this._defaultInputDeviceStream.getTracks().forEach(function (track) {
          return track.stop();
        });

        this._defaultInputDeviceStream = null;

        this._destroyProcessedStream();
      }
    }
    /**
     * Unbind the listeners from mediaDevices.
     * @private
     */

  }, {
    key: "_unbind",
    value: function _unbind() {
      var _a;

      if ((_a = this._mediaDevices) === null || _a === void 0 ? void 0 : _a.removeEventListener) {
        this._mediaDevices.removeEventListener('devicechange', this._updateAvailableDevices);
      }
    }
    /**
     * Update AudioHelper options that can be changed by the user
     * @private
     */

  }, {
    key: "_updateUserOptions",
    value: function _updateUserOptions(options) {
      if (typeof options.enumerateDevices === 'function') {
        this._enumerateDevices = options.enumerateDevices;
      }

      if (typeof options.getUserMedia === 'function') {
        this._getUserMedia = options.getUserMedia;
      }
    }
    /**
     * Adds an {@link AudioProcessor} object. Once added, the AudioHelper will route
     * the input audio stream through the processor before sending the audio
     * stream to Twilio. Only one AudioProcessor can be added at this time.
     *
     * See the {@link AudioProcessor} interface for an example.
     *
     * @param processor The AudioProcessor to add.
     * @returns
     */

  }, {
    key: "addProcessor",
    value: function addProcessor(processor) {
      this._log.debug('.addProcessor');

      if (this._processor) {
        throw new NotSupportedError('Adding multiple AudioProcessors is not supported at this time.');
      }

      if (typeof processor !== 'object' || processor === null) {
        throw new InvalidArgumentError('Missing AudioProcessor argument.');
      }

      if (typeof processor.createProcessedStream !== 'function') {
        throw new InvalidArgumentError('Missing createProcessedStream() method.');
      }

      if (typeof processor.destroyProcessedStream !== 'function') {
        throw new InvalidArgumentError('Missing destroyProcessedStream() method.');
      }

      this._processor = processor;

      this._audioProcessorEventObserver.emit('add');

      return this._restartStreams();
    }
    /**
     * Enable or disable the disconnect sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */

  }, {
    key: "disconnect",
    value: function disconnect(doEnable) {
      this._log.debug('.disconnect', doEnable);

      return this._maybeEnableSound(Device.SoundName.Disconnect, doEnable);
    }
    /**
     * Enable or disable the incoming sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */

  }, {
    key: "incoming",
    value: function incoming(doEnable) {
      this._log.debug('.incoming', doEnable);

      return this._maybeEnableSound(Device.SoundName.Incoming, doEnable);
    }
    /**
     * Enable or disable the outgoing sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */

  }, {
    key: "outgoing",
    value: function outgoing(doEnable) {
      this._log.debug('.outgoing', doEnable);

      return this._maybeEnableSound(Device.SoundName.Outgoing, doEnable);
    }
    /**
     * Removes an {@link AudioProcessor}. Once removed, the AudioHelper will start using
     * the audio stream from the selected input device for existing or future calls.
     *
     * @param processor The AudioProcessor to remove.
     * @returns
     */

  }, {
    key: "removeProcessor",
    value: function removeProcessor(processor) {
      this._log.debug('.removeProcessor');

      if (typeof processor !== 'object' || processor === null) {
        throw new InvalidArgumentError('Missing AudioProcessor argument.');
      }

      if (this._processor !== processor) {
        throw new InvalidArgumentError('Cannot remove an AudioProcessor that has not been previously added.');
      }

      this._destroyProcessedStream();

      this._processor = null;

      this._audioProcessorEventObserver.emit('remove');

      return this._restartStreams();
    }
    /**
     * Set the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. Any deviceId specified here will be ignored. Instead, device IDs should
     * be specified using {@link AudioHelper#setInputDevice}. The returned Promise resolves
     * when the media is successfully reacquired, or immediately if no input device is set.
     * @param audioConstraints - The MediaTrackConstraints to apply.
     */

  }, {
    key: "setAudioConstraints",
    value: function setAudioConstraints(audioConstraints) {
      this._log.debug('.setAudioConstraints', audioConstraints);

      this._audioConstraints = Object.assign({}, audioConstraints);
      delete this._audioConstraints.deviceId;
      return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    }
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     */

  }, {
    key: "setInputDevice",
    value: function setInputDevice(deviceId) {
      this._log.debug('.setInputDevice', deviceId);

      return this._setInputDevice(deviceId, false);
    }
    /**
     * Unset the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. The returned Promise resolves when the media is successfully reacquired,
     * or immediately if no input device is set.
     */

  }, {
    key: "unsetAudioConstraints",
    value: function unsetAudioConstraints() {
      this._log.debug('.unsetAudioConstraints');

      this._audioConstraints = null;
      return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    }
    /**
     * Unset the input device, stopping the tracks. This should only be called when not in a connection, and
     *   will not allow removal of the input device during a live call.
     */

  }, {
    key: "unsetInputDevice",
    value: function unsetInputDevice() {
      var _this4 = this;

      this._log.debug('.unsetInputDevice', this.inputDevice);

      if (!this.inputDevice) {
        return Promise.resolve();
      }

      this._destroyProcessedStream();

      return this._onActiveInputChanged(null).then(function () {
        _this4._replaceStream(null);

        _this4._inputDevice = null;

        _this4._maybeStopPollingVolume();
      });
    }
    /**
     * Destroys processed stream and update references
     */

  }, {
    key: "_destroyProcessedStream",
    value: function _destroyProcessedStream() {
      if (this._processor && this._processedStream) {
        this._log.info('destroying processed stream');

        var processedStream = this._processedStream;

        this._processedStream.getTracks().forEach(function (track) {
          return track.stop();
        });

        this._processedStream = null;

        this._processor.destroyProcessedStream(processedStream);

        this._audioProcessorEventObserver.emit('destroy');
      }
    }
    /**
     * Get the index of an un-labeled Device.
     * @param mediaDeviceInfo
     * @returns The index of the passed MediaDeviceInfo
     */

  }, {
    key: "_getUnknownDeviceIndex",
    value: function _getUnknownDeviceIndex(mediaDeviceInfo) {
      var id = mediaDeviceInfo.deviceId;
      var kind = mediaDeviceInfo.kind;
      var index = this._unknownDeviceIndexes[kind][id];

      if (!index) {
        index = Object.keys(this._unknownDeviceIndexes[kind]).length + 1;
        this._unknownDeviceIndexes[kind][id] = index;
      }

      return index;
    }
    /**
     * Initialize output device enumeration.
     */

  }, {
    key: "_initializeEnumeration",
    value: function _initializeEnumeration() {
      var _this5 = this;

      if (!this._mediaDevices || !this._enumerateDevices) {
        throw new NotSupportedError('Enumeration is not supported');
      }

      if (this._mediaDevices.addEventListener) {
        this._mediaDevices.addEventListener('devicechange', this._updateAvailableDevices);
      }

      this._updateAvailableDevices().then(function () {
        if (!_this5.isOutputSelectionSupported) {
          return;
        }

        Promise.all([_this5.speakerDevices.set('default'), _this5.ringtoneDevices.set('default')]).catch(function (reason) {
          _this5._log.warn("Warning: Unable to set audio output devices. ".concat(reason));
        });
      });
    }
    /**
     * Route input stream to the processor if it exists
     */

  }, {
    key: "_maybeCreateProcessedStream",
    value: function _maybeCreateProcessedStream(stream) {
      var _this6 = this;

      if (this._processor) {
        this._log.info('Creating processed stream');

        return this._processor.createProcessedStream(stream).then(function (processedStream) {
          _this6._processedStream = processedStream;

          _this6._audioProcessorEventObserver.emit('create');

          return _this6._processedStream;
        });
      }

      return Promise.resolve(stream);
    }
    /**
     * Set whether the sound is enabled or not
     * @param soundName
     * @param doEnable
     * @returns Whether the sound is enabled or not
     */

  }, {
    key: "_maybeEnableSound",
    value: function _maybeEnableSound(soundName, doEnable) {
      if (typeof doEnable !== 'undefined') {
        this._enabledSounds[soundName] = doEnable;
      }

      return this._enabledSounds[soundName];
    }
    /**
     * Stop the tracks on the current input stream before replacing it with the passed stream.
     * @param stream - The new stream
     */

  }, {
    key: "_replaceStream",
    value: function _replaceStream(stream) {
      this._log.info('Replacing with new stream.');

      if (this._selectedInputDeviceStream) {
        this._log.info('Old stream detected. Stopping tracks.');

        this._stopSelectedInputDeviceStream();
      }

      this._selectedInputDeviceStream = stream;
    }
    /**
     * Restart the active streams
     */

  }, {
    key: "_restartStreams",
    value: function _restartStreams() {
      if (this.inputDevice && this._selectedInputDeviceStream) {
        this._log.info('Restarting selected input device');

        return this._setInputDevice(this.inputDevice.deviceId, true);
      }

      if (this._defaultInputDeviceStream) {
        var defaultDevice = this.availableInputDevices.get('default') || Array.from(this.availableInputDevices.values())[0];

        this._log.info('Restarting default input device, now becoming selected.');

        return this._setInputDevice(defaultDevice.deviceId, true);
      }

      return Promise.resolve();
    }
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     * @param forceGetUserMedia - If true, getUserMedia will be called even if
     *   the specified device is already active.
     */

  }, {
    key: "_setInputDevice",
    value: function _setInputDevice(deviceId, forceGetUserMedia) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this7 = this;

        var setInputDevice;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setInputDevice = function setInputDevice() {
                  return __awaiter(_this7, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                    var _this8 = this;

                    var device, constraints;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return this._beforeSetInputDevice();

                          case 2:
                            if (!(typeof deviceId !== 'string')) {
                              _context.next = 4;
                              break;
                            }

                            return _context.abrupt("return", Promise.reject(new InvalidArgumentError('Must specify the device to set')));

                          case 4:
                            device = this.availableInputDevices.get(deviceId);

                            if (device) {
                              _context.next = 7;
                              break;
                            }

                            return _context.abrupt("return", Promise.reject(new InvalidArgumentError("Device not found: ".concat(deviceId))));

                          case 7:
                            this._log.info('Setting input device. ID: ' + deviceId);

                            if (!(this._inputDevice && this._inputDevice.deviceId === deviceId && this._selectedInputDeviceStream)) {
                              _context.next = 13;
                              break;
                            }

                            if (forceGetUserMedia) {
                              _context.next = 11;
                              break;
                            }

                            return _context.abrupt("return", Promise.resolve());

                          case 11:
                            // If the currently active track is still in readyState `live`, gUM may return the same track
                            // rather than returning a fresh track.
                            this._log.info('Same track detected on setInputDevice, stopping old tracks.');

                            this._stopSelectedInputDeviceStream();

                          case 13:
                            // Release the default device in case it was created previously
                            this._stopDefaultInputDeviceStream();

                            constraints = {
                              audio: Object.assign({
                                deviceId: {
                                  exact: deviceId
                                }
                              }, this.audioConstraints)
                            };

                            this._log.info('setInputDevice: getting new tracks.');

                            return _context.abrupt("return", this._getUserMedia(constraints).then(function (originalStream) {
                              _this8._destroyProcessedStream();

                              return _this8._maybeCreateProcessedStream(originalStream).then(function (newStream) {
                                _this8._log.info('setInputDevice: invoking _onActiveInputChanged.');

                                return _this8._onActiveInputChanged(newStream).then(function () {
                                  _this8._replaceStream(originalStream);

                                  _this8._inputDevice = device;

                                  _this8._maybeStartPollingVolume();
                                });
                              });
                            }));

                          case 17:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));
                };

                return _context2.abrupt("return", this._inputDevicePromise = setInputDevice().finally(function () {
                  _this7._inputDevicePromise = null;
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Remove event listener for microphone permissions
     */

  }, {
    key: "_stopMicrophonePermissionListener",
    value: function _stopMicrophonePermissionListener() {
      var _a;

      if ((_a = this._microphonePermissionStatus) === null || _a === void 0 ? void 0 : _a.removeEventListener) {
        this._microphonePermissionStatus.removeEventListener('change', this._onMicrophonePermissionStatusChanged);
      }
    }
    /**
     * Stop the selected audio stream
     */

  }, {
    key: "_stopSelectedInputDeviceStream",
    value: function _stopSelectedInputDeviceStream() {
      if (this._selectedInputDeviceStream) {
        this._log.info('Stopping selected device stream');

        this._selectedInputDeviceStream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
    }
    /**
     * Update a set of devices.
     * @param updatedDevices - An updated list of available Devices
     * @param availableDevices - The previous list of available Devices
     * @param removeLostDevice - The method to call if a previously available Device is
     *   no longer available.
     */

  }, {
    key: "_updateDevices",
    value: function _updateDevices(updatedDevices, availableDevices, removeLostDevice) {
      var _this9 = this;

      var updatedDeviceIds = updatedDevices.map(function (d) {
        return d.deviceId;
      });
      var knownDeviceIds = Array.from(availableDevices.values()).map(function (d) {
        return d.deviceId;
      });
      var lostActiveDevices = []; // Remove lost devices

      var lostDeviceIds = difference(knownDeviceIds, updatedDeviceIds);
      lostDeviceIds.forEach(function (lostDeviceId) {
        var lostDevice = availableDevices.get(lostDeviceId);

        if (lostDevice) {
          availableDevices.delete(lostDeviceId);

          if (removeLostDevice(lostDevice)) {
            lostActiveDevices.push(lostDevice);
          }
        }
      }); // Add any new devices, or devices with updated labels

      var deviceChanged = false;
      updatedDevices.forEach(function (newDevice) {
        var existingDevice = availableDevices.get(newDevice.deviceId);

        var newMediaDeviceInfo = _this9._wrapMediaDeviceInfo(newDevice);

        if (!existingDevice || existingDevice.label !== newMediaDeviceInfo.label) {
          availableDevices.set(newDevice.deviceId, newMediaDeviceInfo);
          deviceChanged = true;
        }
      });

      if (deviceChanged || lostDeviceIds.length) {
        // Force a new gUM in case the underlying tracks of the active stream have changed. One
        //   reason this might happen is when `default` is selected and set to a USB device,
        //   then that device is unplugged or plugged back in. We can't check for the 'ended'
        //   event or readyState because it is asynchronous and may take upwards of 5 seconds,
        //   in my testing. (rrowland)
        var defaultId = 'default'; // this.inputDevice is not null if audio.setInputDevice() was explicitly called

        var isInputDeviceSet = this.inputDevice && this.inputDevice.deviceId === defaultId; // If this.inputDevice is null, and default stream is not null, it means
        // the user is using the default stream and did not explicitly call audio.setInputDevice()

        var isDefaultDeviceSet = this._defaultInputDeviceStream && this.availableInputDevices.get(defaultId);

        if (isInputDeviceSet || isDefaultDeviceSet) {
          this._log.warn("Calling getUserMedia after device change to ensure that the           tracks of the active device (default) have not gone stale."); // NOTE(csantos): Updating the stream in the same execution context as the devicechange event
          // causes the new gUM call to fail silently. Meaning, the gUM call may succeed,
          // but it won't actually update the stream. We need to update the stream in a different
          // execution context (setTimeout) to properly update the stream.


          setTimeout(function () {
            _this9._setInputDevice(defaultId, true);
          }, 0);
        }

        this._log.debug('#deviceChange', lostActiveDevices);

        this.emit('deviceChange', lostActiveDevices);
      }
    }
    /**
     * Disconnect the old input volume source, and create and connect a new one with the current
     * input stream.
     */

  }, {
    key: "_updateVolumeSource",
    value: function _updateVolumeSource() {
      if (!this.inputStream || !this._audioContext || !this._inputVolumeAnalyser) {
        return;
      }

      if (this._inputVolumeSource) {
        this._inputVolumeSource.disconnect();
      }

      try {
        this._inputVolumeSource = this._audioContext.createMediaStreamSource(this.inputStream);

        this._inputVolumeSource.connect(this._inputVolumeAnalyser);
      } catch (ex) {
        this._log.warn('Unable to update volume source', ex);

        delete this._inputVolumeSource;
      }
    }
    /**
     * Convert a MediaDeviceInfo to a IMediaDeviceInfoShim.
     * @param mediaDeviceInfo - The info to convert
     * @returns The converted shim
     */

  }, {
    key: "_wrapMediaDeviceInfo",
    value: function _wrapMediaDeviceInfo(mediaDeviceInfo) {
      var options = {
        deviceId: mediaDeviceInfo.deviceId,
        groupId: mediaDeviceInfo.groupId,
        kind: mediaDeviceInfo.kind,
        label: mediaDeviceInfo.label
      };

      if (!options.label) {
        if (options.deviceId === 'default') {
          options.label = 'Default';
        } else {
          var index = this._getUnknownDeviceIndex(mediaDeviceInfo);

          options.label = "Unknown ".concat(kindAliases[options.kind], " Device ").concat(index);
        }
      }

      return new MediaDeviceInfoShim(options);
    }
  }]);

  return AudioHelper;
}(EventEmitter);

(function (AudioHelper) {})(AudioHelper || (AudioHelper = {}));

export default AudioHelper;